import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { IActionUrlForm } from '../types/ActionUrl';

import styles from '../styles/ActionUrl.module.css';

type Parameter = {
  parameterName: string;
  parameterValue?: string;
};

function buildQueryString(parameters: Parameter[]): string {
  const query = parameters
    .filter((p) => p.parameterName && p.parameterValue !== undefined)
    .map((p) => `${encodeURIComponent(p.parameterName)}={${encodeURIComponent(p.parameterValue!)}}`)
    .join('&');

  return query ? `?${query}` : '';
}

export const LinkPreview = () => {
  const { t } = useTranslation();
  const { values, errors } = useFormikContext<IActionUrlForm>();

  const url = values.url;
  const parameterString = buildQueryString(values.parameters);

  const previewUrl = `${url}${parameterString}`;

  if (!url || errors.url) {
    return null;
  }

  return (
    <div className={styles.linkPreviewWrapper}>
      {t('common:preview')}: <a href={previewUrl} target="_blank" rel="noreferrer">{previewUrl}</a>
    </div>
  );
};